import HttpService from './httpService';
import config from '../../config';

class ClientesApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async obtenerDetallesCliente({ ccodcli, headquarter }) {
    return this.get('obtenerDetallesCliente', {
      params: { ccodcli, headquarter },
    });
  }

  async buscarClientes({ ccodcli, nombreFiscal, nombreComercial, cif, email, headquarter }) {
    return this.get('buscarClientes', {
      params: { ccodcli, nombreFiscal, nombreComercial, cif, email, headquarter },
    });
  }

  async crearCliente({
    nombreFiscal,
    nombreComercial,
    domicilio,
    poblacion,
    codigoPostal,
    provincia,
    pais,
    cif,
    telefono,
    movil,
    email,
    personaContacto,
    observaciones,
    headquarter,
  }) {
    return this.post('crearCliente', {
      nombreFiscal,
      nombreComercial,
      domicilio,
      poblacion,
      codigoPostal,
      provincia,
      pais,
      cif,
      telefono,
      movil,
      email,
      personaContacto,
      observaciones,
      headquarter,
    });
  }

  async actualizarCliente({
    nombreFiscal,
    nombreComercial,
    domicilio,
    poblacion,
    codigoPostal,
    provincia,
    pais,
    cif,
    telefono,
    movil,
    email,
    personaContacto,
    observaciones,
    headquarter,
    ccodcli,
  }) {
    return this.put('actualizarCliente', {
      nombreFiscal,
      nombreComercial,
      domicilio,
      poblacion,
      codigoPostal,
      provincia,
      pais,
      cif,
      telefono,
      movil,
      email,
      personaContacto,
      observaciones,
      headquarter,
      ccodcli,
    });
  }
}

const clientesApiService = new ClientesApiService(config.REACT_APP_NODE_API);

export default clientesApiService;
